import { createLogRecord, formatConsoleLogRecord, formatTimestamp, type ConsoleMethod, type JsonConsoleLoggerOptions } from './json-logger';

const PATCH_FLAG = Symbol.for('sus.front.jsonConsoleLoggerInstalled');
const ORIGINAL_CONSOLE = Symbol.for('sus.front.originalConsoleMethods');

type OriginalConsoleMethods = Record<ConsoleMethod, (...args: unknown[]) => void>;

/**
 * 원본 console 참조를 전역에 1회만 보관해 복구 가능하게 합니다.
 */
function getOriginalConsoleMethods(): OriginalConsoleMethods {
  const globalRecord = globalThis as typeof globalThis & Record<symbol, unknown>;

  if (!globalRecord[ORIGINAL_CONSOLE]) {
    globalRecord[ORIGINAL_CONSOLE] = {
      debug: console.debug.bind(console),
      error: console.error.bind(console),
      info: console.info.bind(console),
      log: console.log.bind(console),
      warn: console.warn.bind(console),
    };
  }

  return globalRecord[ORIGINAL_CONSOLE] as OriginalConsoleMethods;
}

/**
 * console 출력 파이프라인을 JSONL 처리와 운영자 텍스트 로그로 교체합니다.
 */
export function installJsonConsoleLogger(options: JsonConsoleLoggerOptions = {}): void {
  const globalRecord = globalThis as typeof globalThis & Record<symbol, unknown>;

  if (globalRecord[PATCH_FLAG]) {
    return;
  }

  const originalMethods = getOriginalConsoleMethods();

  (Object.keys(originalMethods) as ConsoleMethod[]).forEach(method => {
    console[method] = (...args: unknown[]) => {
      try {
        const record = createLogRecord(method, args, options.runtime);
        const jsonLine = JSON.stringify(record);

        options.writeJsonLine?.(jsonLine, record);
        originalMethods[method](formatConsoleLogRecord(record));
      } catch (error) {
        originalMethods.error(`[${formatTimestamp()}][ERROR][logging][ERROR] JSON 로그 변환 실패 exception=${error instanceof Error ? error.name : 'UnknownError'}`);
      }
    };
  });

  globalRecord[PATCH_FLAG] = true;
}
